<template>
	<div id='app'>
		<modal-window v-model='showAjaxErrorsModal' style='z-index: 100' width='25rem' :no-padding='true'>
			<div slot='main'>
				<p :key='error' v-for='error in this.$store.state.ajaxErrors' style='margin: 1rem;'>{{ $t(error[0].toLowerCase() + error.slice(1)) }}</p>
			</div>
			<button
				slot='footer'
				class='button button--modal'
				@click='showAjaxErrorsModal = false'
				ref='ajaxErrorsModalButton'
			>
				OK
			</button>
		</modal-window>
		<IDCNav
			:options='langOptions'
			v-model='$i18n.locale'>
		</IDCNav>
		<not-found v-show='$store.state.show404Page'></not-found>

		<transition name='fade'>
			<router-view v-show='!$store.state.show404Page'></router-view>
		</transition>
		<IDCFooter></IDCFooter>

		<!-- Login -->
		<b-modal id="loginModal" size="lg" hide-header hide-footer>
			<div class="fadeIn">
				<div class="modal-dialog modal-dialog-centered modal-lg m-0">
					<div class="modal-content bgDarkTexture">
						<div class="d-flex flex-column align-items-center justify-content-center m-3 p-xl-2 px-lg-2 py-lg-2 px-5 py-2">
							<div class="align-self-md-end align-self-start noYetRegistered">
								<p class="mb-1">Not a member yet?
									<a href="#" class="text-primary pl-2 bordered-bottom-sm" v-b-modal.registerModal @click="$bvModal.hide('loginModal')">
										Register Now!
										<font-awesome-icon :icon="{ prefix: 'fa', iconName: 'chevron-right' }" />
									</a>
								</p>
							</div>
							<div class="modalMainContentContainer px-lg-3">
								<div class="formularyAccount">
									<h2 class="display-4 bordered-bottom animated slideInLeft fast mt-2">Login</h2>
									<h3 class="h6 pt-1 fontSecondarySmall text-primary animated fadeIn pt-2">Log in to your account and start playing right now!</h3>
									<div class="getAuth loginForm">
										<div class="form-group">											
											<input 	type="text" 
													class="form-control mt-3 p-3 borderPrimaryColor bg-transparent auth-control" 
													:placeholder="`${ $t('forum_username') }`" 
													autocomplete="off" 
													v-model='login.username'>
											<p class="callbackLogin text-danger">{{ login.errors.username }}</p>

											<input type="password" class="form-control mt-3 p-3 borderPrimaryColor bg-transparent auth-control" placeholder="Password" autocomplete="off" v-model='login.password'>
											<p class="callbackLogin text-danger">{{ login.errors.hash }}</p>

											<div class="row mx-0 ml-2">
												<div class="form-check col-6">
													<input type="checkbox" class="form-check-input" id="loggedIn" checked="checked">
													<label class="form-check-label" for="loggedIn">Stay connected</label>
												</div>
												<div class="col-6 text-right"><a href="https://en.idcgames.com/extra/forgotten-password" class="text-primary">Forgot your password?</a></div>
											</div>
											<p class="callbackLogin mt-3 text-danger">{{ login.errors.message }}</p>
											<loading-button
												class='btn-cta text-dark'
												:loading='login.loading'
												@click='doLogin'
											>
												Login
											</loading-button>
										</div>
									</div>
								</div>
								<div class="col d-flex flex-column mt-xl-5 pt-2 px-0">
									<div><h4>or start session with</h4></div>
									<div class="d-flex flex-row flex-wrap align-items-center justify-content-start">
										<button class="btn-google btn-social fontPrimarySmall m-1" data-opt="login">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'google' }" />
											Sign in with <b>Google</b>
										</button>
										<button class="btn-facebook btn-social fontPrimarySmall m-1" data-opt="login">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook-square' }" />
											Sign in with <b>Facebook</b>
										</button>
										<button type="button" class="btn-social btn-steam fontPrimarySmall m-1">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'steam-symbol' }" />
											Sign in with <b>Steam</b>                
										</button>
										<button type="button" class="btn-social btn-twitter fontPrimarySmall m-1" data-id="twitterbtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'twitter' }" />
											Sign in with <b>Twitter</b>
										</button>
										<button type="button" class="btn-social btn-yahoo fontPrimarySmall m-1" data-id="yahoobtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'yahoo' }" />
											Sign in with <b>Yahoo</b>
										</button>
										<button type="button" class="btn-social btn-msn fontPrimarySmall m-1" data-id="msnbtnLogin">
											<font-awesome-icon :icon="{prefix: 'fab', iconName: 'microsoft'}" />
											Sign in with <b>MSN</b>
										</button>
										<button type="button" class="btn-social btn-discord fontPrimarySmall m-1">
											<font-awesome-icon :icon="{prefix: 'fab', iconName: 'discord'}" />
											Sign in with <b>Discord</b>
										</button>
										<button type="button" class="btn-social btn-twitch fontPrimarySmall m-1">
											<font-awesome-icon :icon="{prefix: 'fab', iconName: 'twitch'}" />
											Sign in with <b>Twitch</b>
										</button>
									</div>
								</div>
								<div class="pt-xl-4 pt-2">									
									<p class="fontPrimarySmall">By signing up, I agree to the Legal conditions, the Privacy Policy and the use of cookies of IDC/Games.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal id="registerModal" size="lg" hide-header hide-footer>
			<div class="fadeIn">
				<div class="modal-dialog modal-dialog-centered modal-lg m-0">
					<div class="modal-content bgDarkTexture">
						<div class="d-flex flex-column align-items-center justify-content-center m-3 p-xl-2 px-lg-2 py-lg-2 px-5 py-2">
							<div class="align-self-md-end align-self-start noYetRegistered">
								<p class="mb-1">Are you a member?
									<a href="#" class="text-primary pl-2 bordered-bottom-sm" v-b-modal.loginModal  @click="$bvModal.hide('registerModal')">
										Login now!
										<font-awesome-icon :icon="{ prefix: 'fa', iconName: 'chevron-right' }" />
									</a>
								</p>
							</div>
							<div class="modalMainContentContainer px-lg-3">
								<div class="formularyAccount">
									<h2 class="display-4 bordered-bottom animated slideInLeft fast mt-2">New at IDC Games?</h2>
									<h3 class="h6 pt-1 fontSecondarySmall text-primary animated fadeIn pt-2">Create your FREE account and start playing right now!</h3>
									<div class="getAuth registerForm">
										<div class="form-group">

											<input 	type="text" 
													class="form-control mt-3 p-3 borderPrimaryColor bg-transparent auth-control"
													:class="{'border-danger': signup.errors.username}"
													:placeholder="`${ $t('forum_username') }`"
													autocomplete="off" 
													v-model='signup.username'
													@change="usercheck"													
													>
											<loading-button 
												v-if="signup.checking"
												class="py-1"
												:loading='signup.checking'>
											</loading-button>
											<p class="callbackLogin text-danger">{{ signup.errors.username }}</p>

											<div class="row my-3 mx-0">

												<div class="col-6 pr-2 pl-0">
													<input 	type="password" 
															class="form-control mt-0 p-3 borderPrimaryColor bg-transparent colorLight auth-control" placeholder="Password" 
															autocomplete="off" 
															v-model='signup.password'
															@change="checkInitPass"
															>
													<p class="callbackLogin text-danger">{{ signup.errors.hash }}</p>
												</div>

												<div class="col-6 pl-2 pr-0">
													<input 	type="password" 
															class="form-control mt-0 p-3 borderPrimaryColor bg-transparent colorLight auth-control" placeholder="Password" 
															autocomplete="off" 
															v-model='signup.confirmPassword'
															@change="checkPass"
															>
													<p class="callbackLogin text-danger">{{ signup.errors.confirmPassword }}</p>
												</div>												
											</div>											
											
											<div class="row my-3 mx-0">
												<div class="form-check col-6 ml-2">
													<input type="checkbox" class="form-check-input" id="registerIn" checked="checked">
													<label class="form-check-label" for="registerIn">Stay connected</label>
												</div>
											</div>

											<p class="callbackLogin mt-3 text-danger">{{ signup.errors.message }}</p>
											<loading-button
												class='btn-cta text-dark'
												:loading='signup.loading'
												@click='createAccount'
											>
												Register
											</loading-button>
										</div>
									</div>
								</div>
								<div class="col d-flex flex-column mt-xl-5 pt-2 px-0">
									<div><h4>or start session with:</h4></div>
									<div class="d-flex flex-row flex-wrap align-items-center justify-content-start">
										<button class="btn-google btn-social fontPrimarySmall m-1" data-opt="login">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'google' }" />
											Sign in with <b>Google</b>
										</button>
										<button class="btn-facebook btn-social fontPrimarySmall m-1" data-opt="login">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook-square' }" />
											Sign in with <b>Facebook</b>
										</button>
										<button type="button" class="btn-social btn-steam fontPrimarySmall m-1">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'steam-symbol' }" />
											Sign in with <b>Steam</b>
										</button>
										<button type="button" class="btn-social btn-twitter fontPrimarySmall m-1" data-id="twitterbtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'twitter' }" />
											Sign in with <b>Twitter</b>
										</button>
										<button type="button" class="btn-social btn-yahoo fontPrimarySmall m-1" data-id="yahoobtnLogin">
											<font-awesome-icon :icon="{ prefix: 'fab', iconName: 'yahoo' }" />
											Sign in with <b>Yahoo</b>
										</button>
										<button type="button" class="btn-social btn-msn fontPrimarySmall m-1" data-id="msnbtnLogin">
											<font-awesome-icon :icon="{prefix: 'fab', iconName: 'microsoft'}" />
											Sign in with <b>MSN</b>
										</button>
										<button type="button" class="btn-social btn-discord fontPrimarySmall m-1">
											<font-awesome-icon :icon="{prefix: 'fab', iconName: 'discord'}" />
											Sign in with <b>Discord</b>
										</button>
										<button type="button" class="btn-social btn-twitch fontPrimarySmall m-1">
											<font-awesome-icon :icon="{prefix: 'fab', iconName: 'twitch'}" />
											Sign in with <b>Twitch</b>
										</button>
									</div>
								</div>
								<div class="pt-xl-4 pt-2">
									<p class="fontPrimarySmall">By signing up, I agree to the Legal conditions, the Privacy Policy and the use of cookies of IDC/Games.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import ModalWindow from './components/ModalWindow'
	import TabView from './components/TabView'
	import FancyInput from './components/FancyInput'
	import LoadingButton from './components/LoadingButton'
	import NotificationButton from './components/NotificationButton'
	import SearchBox from './components/SearchBox'
	import SelectButton from './components/SelectButton'

	import NotFound from './components/routes/NotFound'

	import AjaxErrorHandler from './assets/js/errorHandler'
	import IDCFooter from './components/Footer';
	import IDCNav from './components/NavBar';

	export default {
    name: 'app',
		components: {
			ModalWindow,
			TabView,
			FancyInput,
			LoadingButton,
			NotificationButton,
			SearchBox,
			NotFound,
			SelectButton,
			IDCFooter,
			IDCNav
		},
		data () {
			return {
				signup: {
					username: '',
					password: '',
					confirmPassword: '',
					loading: false,
					checking: false,
					errors: {
						username: '',
						hash: '',
						confirmPassword: '',
						message: ''
					}
				},
				login: {
					username: '',
					password: '',
					loading: false,
					errors: {
						username: '',
						hash: '',
						message: ''
					}
				},
				loadingLogout: false,
				showMenu: false,
				ajaxErrorHandler: AjaxErrorHandler(this.$store),
				idc_logo: require("./assets/img/default/logo-idc-light.png")
			}
		},
		metaInfo(){

			if(this.$store.state.show404Page)
			{
				return {
					title: `IDCGames Forum - 404`,
					meta: [
						{ name: 'description', content: `Content not found` }
					]
				}
			}

			var gameName = (this.$store.state.gameID && this.$store.state.meta.gamesDict[this.$store.state.gameID] && this.$store.state.meta.gamesDict[this.$store.state.gameID].name) || ''
			if(gameName) gameName = ' - ' + gameName
			
			return {
				title: `IDCGames Forum${gameName}`,
				meta: [
					{ name: 'description', content: `IDCGames Forum${gameName}` }
				]
			}
		},
		computed: {
			langOptions () {
				return Object.keys(this.$i18n.messages).map(x => ({ name: x.toUpperCase(), value: x }))
			},
			name () {
				return this.$store.state.meta.name
			},
			showAccountModal: {
				get () { 
					 
					return this.$store.state.accountModal 
				},
				set (val) {
					this.$store.commit('setAccountModalState', val);
				}
			},
			showAjaxErrorsModal: {
				get () { return this.$store.state.ajaxErrorsModal },
				set (val) { this.$store.commit('setAjaxErrorsModalState', val) }
			},
			showAccountTab : {
				get () { return this.$store.state.accountTabs },
				set (index) { this.$store.commit('setAccountTabs', index) }
			},
			categories() {
				return this.$store.state.meta.categories
			},
			games() {
				return this.$store.state.meta.games
			}
		},
		methods: {
			showLoginModal(){
				
				let element = this.$refs.modal.$el
				$(element).modal('show')
			},
			showAccountModalTab (index) {
				this.toggleMenu()
				this.showAccountModal = true
				this.showAccountTab = index
			},
			clearSignup () {
				this.signup.username = ''
				this.signup.password = ''
				this.signup.confirmPassword = ''

				this.$store.commit('setToken', null)
			},
			clearSignupErrors () {
				this.signup.errors.username = ''
				this.signup.errors.hash = ''
				this.signup.errors.confirmPassword = ''
			},
			clearLogin () {
				this.login.username = ''
				this.login.password = ''
			},
			clearLoginErrors () {
				this.login.errors.username = ''
				this.login.errors.hash = ''
			},
			closeAccountModal () {
				this.showAccountModal = false
				this.clearLogin()
				this.clearSignup()
				this.clearLoginErrors()
				this.clearSignupErrors()
			},
			usercheck: function(e){
				this.signup.checking = true;

				this.axios.post(`/api/v1/user/checkuser`, {
					username: e.target.value.trim()
				})
				.then(res => {
					this.signup.checking = false;

					if(res.data.success){
						this.signup.errors.username = ""
					}else{
						this.signup.errors.username = res.data.data.replaceAll('+', ' ').toLowerCase();
					}

				}).catch(e => {
					this.signup.checking = false

					this.ajaxErrorHandler(e, (error) => {
						let path = error.path
							if(this.signup.errors[path] !== undefined && this.signup.errors[path] !== undefined) {
								this.signup.errors[path] = error.message
							}
						}
					)
				})
			},
			createAccount () {
				
				this.signup.errors.message = '';
				this.clearSignupErrors()
				this.clearLogin()

				let postParams = {
					username: this.signup.username,
					password: this.signup.password
				}
				if(this.$store.state.token) {
					postParams.admin = true
					postParams.token = this.$store.state.token
				}

				if(!this.signup.username.trim().length){
					this.signup.errors.username = "Please input the username"; return;
				}else if(!this.signup.password.trim().length){
					this.signup.errors.hash = "Please type the password"; return;
				}else if(this.signup.password.trim().length < 6){
					this.signup.errors.hash = `${ this.$t('forum_not_enough') }`; return;
				}

				if(this.signup.password !== this.signup.confirmPassword) {
					this.signup.errors.confirmPassword = 'Passwords must match'
				} else {
					this.signup.loading = true

					this.axios.post('/api/v1/user', postParams).then(res => {
						this.signup.loading = false
						this.$store.commit('setUsername', res.data.username)
						this.$store.commit('setAdmin', res.data.admin)
						this.$bvModal.hide('registerModal')
						this.closeAccountModal()

						this.$cookies.set('forum_id', res.data.id);
						this.$cookies.set('forum_nick', res.data.username);
						this.$cookies.set('forum_token', res.data.token);

						this.$socket.emit('accountEvent')
					}).catch(e => {
						this.signup.loading = false

						this.ajaxErrorHandler(e, (error) => {
							let path = error.path

							if(this.signup.errors[path] !== undefined && this.signup.errors[path] !== undefined) {
								this.signup.errors[path] = error.message
							}
						})
					})
				}
			},
			doLogin () {

				this.login.errors.message = '';
				this.clearSignupErrors()

				if(!this.login.username.trim().length) {
					this.login.errors.username = 'Username must not be blank'
					return
				}
				else if(!this.login.password.trim().length) {
					this.login.errors.hash = 'Password must not be blank'
					return
				}else{
					this.login.errors.username = "";
					this.login.errors.hash = "";
				}

				this.login.loading = true

				this.axios.post(`/api/v1/user/${this.login.username.trim()}/login`, {
					password: this.login.password
				}).then(res => {
					this.login.loading = false
					this.$store.commit('setUsername', res.data.username)
					this.$store.commit('setAdmin', res.data.admin)
					this.$bvModal.hide('loginModal')
					this.closeAccountModal()

					this.$cookies.set('forum_id', res.data.id);
					this.$cookies.set('forum_nick', res.data.username);
					this.$cookies.set('forum_token', res.data.token);

					this.$socket.emit('accountEvent')
				}).catch(e => {
					this.login.loading = false
					this.login.errors.message = e.message.includes('401') ? 'Username/Password Incorrect' : e.message;

				})

     		},

			reloadGame(val) {
				this.$store.dispatch('checkGameValidity', val)
				this.axios.get('/api/v1/settings')
				.then(res => {
					this.$store.commit('setSettings', res.data)
					this.$store.dispatch('setTitle', this.$store.state.meta.title)
				}).catch(err => {
					this.$store.commit('setSettings', {})
					if(err.response.data.errors[0].name === 'noSettings') {
					// this.$router.push('/start')
					} else {
						this.ajaxErrorHandler(err)
					}
				})

				this.axios.get('/api/v1/category')
				.then(res => {
					this.$store.commit('addCategories', res.data)

				//Need categories to have loaded to set
				//the title of the index page
				//but if we're on another page (i.e. title is not set)
				//don't overwrite the title
				if(!this.$store.state.meta.title.length && this.$route.params.category) {
					let selectedCategory = this.$route.params.category
					let category = this.categories.find(c => c.value === selectedCategory)

					this.$store.dispatch('setTitle', category.name)
				}
			})
			.catch(this.ajaxErrorHandler)
			},
			checkUser() {
				this.login.loading = true
				this.axios.post(`/api/v1/user/login/single-sign`, {})
				.then(res => {
					this.login.loading = false
					this.$store.commit('setUsername', res.data.username)
					this.$store.commit('setAdmin', res.data.admin)
					this.$store.commit('setRole', res.data.role)
					this.$socket.emit('accountEvent')
				}).catch(e => {
					this.login.loading = false
					this.$store.commit('setUsername', '')
					this.$store.commit('setAdmin', null)
					this.$store.commit('setRole', '')

					this.ajaxErrorHandler(e, (error) => {
						let path = error.path
							if(this.signup.errors[path] !== undefined && this.signup.errors[path] !== undefined) {
								this.signup.errors[path] = error.message
							}
						}
					)
				})
			},
			checkPass: function(e){

				if((this.signup.password !== this.signup.confirmPassword) || this.signup.password.length < 6) {
					this.signup.errors.confirmPassword = 'Passwords must match'
				}else{
					this.signup.errors.confirmPassword = "";
				}
			},
			checkInitPass: function(e){

				if(this.signup.password.length < 6){
					this.signup.errors.hash = `${ this.$t('forum_not_enough') }`;
				}else{
					this.signup.errors.hash=''
				}				
			}
    },
		created () {
			
			this.axios.get('/api/v1/core/games')
				.then(res => {
					this.$store.commit('addGames', res.data)
					this.reloadGame(this.$store.state.gameID)
					this.checkUser()
				})
				.catch(this.ajaxErrorHandler)

			this.axios.get('/api/v1/core/translation')
				.then(res => {
					if(res.data){
						Object.keys(res.data).map(lang => this.$i18n.setLocaleMessage(lang, res.data[lang] || {}))
					}
				})
				.catch(this.ajaxErrorHandler)
		},
		watch: {
			$route () {
				this.showMenu = false
			},
			'$store.state.ajaxErrorsModal': function(val) {
				if(val) {
					this.$refs.ajaxErrorsModalButton.focus()
				}
			},
			'$store.state.gameID': function(val) {
				this.reloadGame(val)
				this.checkUser()
			}
		}
	}
</script>

<style lang='scss'>
	@import url('https://fonts.googleapis.com/css?family=Lato:300,300i,400,400i,700');
	@import './assets/scss/variables.scss';
	@import './assets/scss/elementStyles.scss';
	@import './assets/scss/nprogress.scss';
	@import './assets/scss/idec.scss';

	html, body {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		color: #fff;
		line-height: 1.5;
		background-color: #13181d;
		@include text;
	}

	* {
		box-sizing: border-box;
	}

	#app {
		height: 100%;
	}

	// .dropdown-menu.show{
	// 	background-color: #000;
	// 	background-image: url("../src/assets/img/textures/noisy_net.png");
	// }
	.dropdown-menu:focus{
		outline: none;
	}

	.header {
		background-repeat: repeat;
		padding: 0.3rem 1rem;
		border-bottom: 1px solid #00ff7f;
		width: 100%;
		position: fixed;
		top: 0;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #000;
		background-image: url("../src/assets/img/textures/noisy_net.png");

		@at-root #{&}__group {
			display: flex;
			align-items: center;
			> * { margin: 0 0.5rem; }
			> *:first-child { margin-left: 0; }
			> *:last-child { margin-right: 0; }
		}

		@at-root #{&}__menu_button {
			position: fixed;
			left: 1rem;
			z-index: 1;
			font-size: 1.5rem;
			top: 1rem;
			display: none;
		}

		@at-root #{&}__overlay {
			width: 100%;
			height: 100%;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1;
			pointer-events: none;
			opacity: 0;
			background-color: hsla(215, 13%, 25%, 0.5);
			transition: all 0.4s;
		}
	}

	.logo {
		@include user-select(none);
		cursor: pointer;
		background: none;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		& img{
			height: 40px;
		}

    &.game {
      font-size: 1rem;
    }

		&:hover, &:visited, &:active {
			outline: none;
		}
	}

	.header__menu_button {
		position: fixed;
		left: 0.8rem;
		z-index: 1;
		font-size: 1.5rem;
		top: 0.5rem;
		display: none;
	}

	@media (max-width: 870px) {
		.route_container {
			// width: calc(100% - 2rem);
			// margin: 0 1rem;
			margin-top: 0rem;
		}

		.logo {
			position: relative;
			z-index: 2;
			max-width: calc(100vw - 7rem);
		}

		.header__menu_button {
			display: inline-block;
			cursor: pointer;
		}

		.header__overlay--show {
			pointer-events: all;
			opacity: 1;
		}

		.header__group > *:first-child {
			margin-left: 1rem;
		}

		.header__group:nth-child(2) {
			position: fixed;
			padding-top: 1.5rem;
			width: 17rem;
			display: flex;
			flex-direction: column;
			z-index: 2;
			background-image: linear-gradient(45deg, springgreen 1%, #314954 50%, #1b1d2c 100%);
			top: 0;
			left: calc(-100% - 2rem);
			height: 100%;
			box-shadow: none;
			transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s ease-in;

			> .button {
				width: 100%;
				border-radius: 0;
				margin: 0;
				margin-bottom: 1rem;
			}

			&::before {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 0.3rem;
				content: '';
				background: linear-gradient(to right, hsl(200, 98%, 43%), hsla(193, 98%, 48%, 1));
			}
		}
		.header__group:nth-child(2).header__group--show {
			left: 0;
			box-shadow: 0 0 1rem rgba(0, 0, 0, 0.4);
		}
		.search_box {
			margin: 0;
			display: inline-block;
		}

		.multi_lang{
			margin-top: 20px;
		}
	}
</style>
<style>
.auth-control > div{
	width: 100%;
}
/*
======================================================================================================================
REGISTER/LOGIN CSS IDC GAMES
======================================================================================================================
*/
.modal-content {
    border: none;
    box-shadow: 1px 3px 9px 3px rgba(0,0,0,0.8);
}

@media (min-width: 1200px) {
    .loginModal .modal-lg, .registerModal .modal-lg {
        max-width: 830px;
    }
}
@media (min-width: 992px) and (max-width: 1199px) {
    .loginModal .modal-lg, .registerModal .modal-lg {
        max-width: 830px;
    }
}
@media (min-width: 768px) and (max-width: 991px) {
    .loginModal .modal-lg, .registerModal .modal-lg {
        max-width: 80vw;
    }
}
@media (min-width: 576px) and (max-width: 767px) {
    .loginModal .modal-lg, .registerModal .modal-lg {
        max-width: 85vw;
    }
}

@media (min-width: 768px) {
   .loginModal .close, .registerModal .close {
        display: none;
    } 
}
@media (max-width: 767px) {
   .loginModal .close, .registerModal .close {
        position: absolute;
        top: 20px;
        right: 20px;
    } 
}

.modal-backdrop {
 position:fixed;
 top:0;
 right:0;
 bottom:0;
 left:0;
 z-index:1040;
}

.modal-backdrop.fade {
 opacity:0;
}
.modal-backdrop.show {
 opacity:.7;
}

/*
================================
Fonts
================================
*/
.alredyRegistered p, .noYetRegistered p {
    font-size: 0.9rem; 
}

/*
================================
Upper link
================================
*/

.alredyRegistered {
    position: absolute;
    top: 15px;
}

.noYetRegistered .lineaHorizontalEstrecha {
    width: 45%;
    float: right;
}
    @media (max-width: 575px) {
       .noYetRegistered .lineaHorizontalEstrecha {
            display: none;
        } 
    }

.alredyRegistered .lineaHorizontalEstrecha {
    width: 40%;
    float: right;
}
    @media (max-width: 575px) {
       .alredyRegistered .lineaHorizontalEstrecha {
            display: none;
        } 
    }

/*
================================
Main container
================================
*/
.modalMainContentContainer {
    position: relative;
    max-width: 100%;
}

.loginModal .btn-cta, .registerModal .btn-cta {
    font-size: 1.7rem;
    padding: 1% 5%;
}
    @media (max-width: 575px) {
        .loginModal .btn-cta, .registerModal .btn-cta {
            font-size: 1.6rem;
            padding: 2% 5%;
        }
    }

/*
================================
Or Register with
================================
*/
.btn-social {
  max-height: 46px;
  width: 182px;
  padding: 10px;
  text-align: center;
  border-radius: 2px;
  white-space: nowrap;
  font-family: 'Jura', sans-serif!important;
}
.modal .btn-social {
  max-height: 40px;
  width: 163px;
  font-size: .7rem;
  line-height: .7rem;
}

.btn-social:focus {
 outline:0;
 box-shadow:0 0 0 .2rem rgba(52,58,64,.5)
}

.btn-msn {
    color: #000;
    background-color: #fff;
    max-height: 41px;
    border-color: rgba(0, 0, 0, .2);
}

.btn-msn svg {
    max-height: 22px;
}
.btn-msn path {
    fill: #FFF;
}

.btn-twitter {
    color: #fff;
    background-color: #00a7e7;
    border-color: rgba(0, 0, 0, .2);
}

.btn-vk {
    color: #fff;
    background-color: #2787f5;
    border-color: rgba(0, 0, 0, .2);
}

.btn-steam {
    color: #fff;
    background-color: #134b7c;
    border-color: rgba(0, 0, 0, .2);
}

.btn-google {
    color: #fff;
    background-color: #e34133;
    border-color: rgba(0, 0, 0, .2);
}

.btn-facebook {
    color: #fff;
    background-color: #3b5998;
    border-color: rgba(0, 0, 0, .2);
}

.btn-twitch {
    color: #FFF;
    background: #451793;
    border-color: rgba(0, 0, 0, .2);
}

.btn-discord {
    color: #fff;
    background-color: #5865f2;
    border-color: rgba(0, 0, 0, .2);
}

/*Responsive basado en la altura de la pantalla y no en el ancho*/
@media (max-height: 740px) {
    .modal .display-4 {
        font-size: 3rem;
        font-weight: 700;
        line-height: 1.2;
    }

    .modal .h6 {
        font-size: 1rem;
    }

    .modal h4 {
        font-size: 1.5rem;
    }
    .loginModal .btn-cta.mt-xl-4, .registerModal .btn-cta.mt-xl-4 {
        margin-top: .25rem !important;
    }
    .modalMainContentContainer .mt-xl-5 {
        margin-top: .75rem !important;
    }

    .modalMainContentContainer .pt-xl-4  {
        padding-top: .5rem !important;
    }
}
/*
======================================================================================================================
Botones de logado/no logado
======================================================================================================================
*/
 .unlogged, .logged {
    display: none;
}
/*
.alert-transparent {
    height:60px;
}
*/
#searchForm .search-control {
    padding-left: 2.375rem;
}

#searchForm .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
}
.loading_button__icon, .loading_button__slot{
	width: unset!important;
}
.btn-msn path{
	fill: black;
}
.callbackLogin{
	font-size: 10pt;
}
.bordered-bottom-sm {
    display: inline-block;
    border-bottom: 8px solid #00ff7f;
}
</style>
